import React from 'react';
import PropTypes from 'prop-types';
import PostCodeComponent from './components/PostCodeComponent';
import ChooseAddressComponent from './components/ChooseAddressComponent';
import InternationalAddressComponent from './components/InternationalAddressComponent';
import LocalAddressComponent from './components/LocalAddressComponent';
import SelectAddressComponent from './components/SelectAddressComponent';
import { CHOOSE_ADD, CHOOSE_ADD_NO, CHOOSE_ADD_YES } from './addressUtils/addressConstants';
import AddManuallyComponent from './components/addManuallyComponent';

const AddressComponentConditional = ({
  type,
  onFindAddressClick,
  onAddManuallyClick,
  formValues,
  chooseAddressHeading,
  isAddMunuallyClicked,
  onSelectAddressClick,
  postCodeAddressList,
  currentIndex,
  isPostCodeListError
}) => {
  return (
    <div>
      <ChooseAddressComponent
        type={type}
        chooseAddressHeading={chooseAddressHeading}
        formValues={formValues}
      />
      {!isAddMunuallyClicked && validateChoosenAddress(formValues, CHOOSE_ADD_YES, type) && (
        <PostCodeComponent
          type={type}
          onFindAddressClick={onFindAddressClick}
          onAddManuallyClick={onAddManuallyClick}
          isAddMunuallyClicked={isAddMunuallyClicked}
          isPostCodeListError={isPostCodeListError}
          formValues={formValues}
        />
      )}

      {validateChoosenAddress(formValues, CHOOSE_ADD_YES, type) && (
        <AddManuallyComponent
          type={type}
          onAddManuallyClick={onAddManuallyClick}
          isAddMunuallyClicked={isAddMunuallyClicked}
        />
      )}
      {validateChoosenAddress(formValues, CHOOSE_ADD_NO, type) && (
        <InternationalAddressComponent type={type} values={formValues} />
      )}
      {isAddMunuallyClicked && validateChoosenAddress(formValues, CHOOSE_ADD_YES, type) && (
        <LocalAddressComponent type={type} />
      )}
      {!isAddMunuallyClicked && postCodeAddressList && postCodeAddressList.length > 0 && (
        <SelectAddressComponent
          type={type}
          onSelectAddressClick={onSelectAddressClick}
          isAddMunuallyClicked={isAddMunuallyClicked}
          postCodeAddressList={postCodeAddressList}
          currentIndex={currentIndex}
          formValues={formValues}
        />
      )}
    </div>
  );
};

AddressComponentConditional.propTypes = {
  type: PropTypes.string,
  postAddressList: PropTypes.array,
  onFindAddressClick: PropTypes.func.isRequired,
  onAddMauallyClick: PropTypes.func.isRequired
};

const validateChoosenAddress = (formValues, value, type) => {
  return formValues[type] && formValues[type][CHOOSE_ADD] && formValues[type][CHOOSE_ADD] === value;
};

export default AddressComponentConditional;
